import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../App.css';

function Play() {
  const rulesPagesCount = 14;
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const images = [];
  for (let i = 1; i <= rulesPagesCount; i++) {
    images.push(`page${i}.png`);
  }

  const itemsPerPage = 3;
  const totalPages = Math.ceil(images.length / itemsPerPage);
  const visibleImages = isMobile ? images : images.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  const handlePrevious = () => {
    setCurrentPage((prev) => (prev === 0 ? totalPages - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev === totalPages - 1 ? 0 : prev + 1));
  };

  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">
        Play <span className="kingthings-organica">BioEra</span>
      </h1>
      <p className="lead text-center mb-5">
        Immerse yourself in our natural world!
        <br />
        BioEra™ is a card game that combines fun, strategy, and learning.
      </p>
      <p className="lead text-center mb-5">

      </p>

      <h2 className="text-center mb-4">Rule Book</h2>

      {/* Desktop View: Carousel */}
      {!isMobile && (
        <div>
          <div className="row mb-4" style={{ minHeight: '500px' }}>
            {visibleImages.map((img, idx) => (
              <div key={img} className="col-12 col-sm-6 col-lg-4 mb-4 d-flex justify-content-center">
                <img
                  src={require(`../img/rules/${img}`)}
                  alt={`Game rule page ${currentPage * itemsPerPage + idx + 1}`}
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '400px', objectFit: 'contain' }}
                />
              </div>
            ))}
          </div>

          {/* Navigation Controls */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2em', marginTop: '2em' }}>
            <button
              onClick={handlePrevious}
              style={{ padding: '0.7em 1em', fontSize: '1.2em', background: '#3eab73', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              <FaChevronLeft />
            </button>
            <span style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
              Pages {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, images.length)} of {images.length}
            </span>
            <button
              onClick={handleNext}
              style={{ padding: '0.7em 1em', fontSize: '1.2em', background: '#3eab73', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              <FaChevronRight />
            </button>
          </div>

          {/* Page Indicators */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5em', marginTop: '1.5em' }}>
            {Array.from({ length: totalPages }).map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentPage(idx)}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  border: 'none',
                  background: idx === currentPage ? '#3eab73' : '#ccc',
                  cursor: 'pointer',
                  transition: 'background 0.3s',
                }}
                aria-label={`Go to page ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      )}

      {/* Mobile View: All Images */}
      {isMobile && (
        <div className="row">
          {images.map((img, idx) => (
            <div key={img} className="col-12 mb-4 d-flex justify-content-center">
              <img
                src={require(`../img/rules/${img}`)}
                alt={`Game rule page ${idx + 1}`}
                className="img-fluid rounded shadow"
                style={{ maxHeight: '400px', objectFit: 'contain' }}
              />
            </div>
          ))}
        </div>
      )}
      <br />
    </div>
  );
}

export default Play;
